import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.msg)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "toast",
        style: _normalizeStyle(_ctx.style),
        onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.animationend && _ctx.animationend(...args)))
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.msg), 1)
      ], 36))
    : _createCommentVNode("", true)
}